var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53333 10.4667L3.53333 8.46667C3.26667 8.2 3.26667 7.8 3.53333 7.53333C3.8 7.26667 4.2 7.26667 4.46667 7.53333L5.33333 8.4V0.666667C5.33333 0.266667 5.6 0 6 0C6.4 0 6.66667 0.266667 6.66667 0.666667V8.4L7.53333 7.53333C7.8 7.26667 8.2 7.26667 8.46667 7.53333C8.73333 7.8 8.73333 8.2 8.46667 8.46667L6.46667 10.4667C6.33333 10.6 6.2 10.6667 6 10.6667C5.8 10.6667 5.66667 10.6 5.53333 10.4667ZM8.66667 4.66667H10C11.1333 4.66667 12 5.53333 12 6.66667V11.3333C12 12.4667 11.1333 13.3333 10 13.3333H2C0.866667 13.3333 0 12.4667 0 11.3333V6.66667C0 5.53333 0.866667 4.66667 2 4.66667H3.33333C3.73333 4.66667 4 4.93333 4 5.33333C4 5.73333 3.73333 6 3.33333 6H2C1.6 6 1.33333 6.26667 1.33333 6.66667V11.3333C1.33333 11.7333 1.6 12 2 12H10C10.4 12 10.6667 11.7333 10.6667 11.3333V6.66667C10.6667 6.26667 10.4 6 10 6H8.66667C8.26667 6 8 5.73333 8 5.33333C8 4.93333 8.26667 4.66667 8.66667 4.66667Z",
    fill: "#0F438A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.183c37630f84f3b5a8d264f4a808c3a6.svg";
export { ForwardRef as ReactComponent };